module.exports = "/assets/data/0326ab893ff3983c2942ec2c15a85954-WS7.data.json";